module.exports = __webpack_public_path__ + "img/white-arrow.4047a705.svg";